var React = require('react');

function LaptopInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"laptop","d":"M0 0h24v24H0z"})),React.createElement("clipPath",{"key":1},React.createElement("use",{"xlinkHref":"#a","overflow":"visible"})),React.createElement("path",{"fill":"white","d":"M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z","key":2})]);
}

LaptopInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = LaptopInline;

LaptopInline.default = LaptopInline;
